import React, {useState} from 'react';
import Spinner from '../reusables/spinner';
import {Modal} from 'react-bootstrap';
import {delete_supplier, delete_user} from '../../redux/actions/adminActions';
import {connect} from 'react-redux';

function DeleteModal({
    show,
    handleClose,
    users,
    deleteUser,
    deleteSupplier,
    accessToken,
    supplier,
    unapproved
}) {

    const [isLoading,
        setIsLoading] = useState(false)

    const handleLoading = () => {
        setIsLoading(true);

        setTimeout(() => setIsLoading(false), 5000)
    }

    const handleDelete = (id) => {
        handleLoading();

        if (!supplier) {
            deleteUser(id, accessToken, handleClose, unapproved)
        } else {
            deleteSupplier(id, accessToken, handleClose, unapproved)
        }
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
                <i class="ri-close-line sectionText--small"></i>
            </div>
            <div className="sectionHeight--mid center">
                <div className="w-100 vAlign">
                    <h2 className="sectionText--mid">Are you sure you want to delete { ' ' } { users?.length > 1 ? 'these' : 'this' } { ' ' } user{ users?.length > 1 && 's' }?</h2>

                    <div className="pt-3 center">
                        {isLoading
                            ? <div className='center'>
                                    <Spinner dark/>
                                </div>
                            : <> <button className="btn__filled mx-2 hasRadius" onClick={handleClose}>No, Cancel</button> < button className = "btn__transparent" onClick = {
                                () => handleDelete(users
                                    )
                            } > Yes,
                        Delete </button>
                        </ >
}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token
})

const mapDispatchToProps = (dispatch) => ({
    deleteSupplier: (id, token, success, unapproved) => dispatch(delete_supplier(id, token, success, unapproved)),
    deleteUser: (id, token, success, unapproved) => dispatch(delete_user(id, token, success, unapproved))
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal)
